import type { AccessRules } from "./AccessRules";
import { Permission } from "./Permission";
import { Role } from "./Role";

export const DojoIslandsAccessRules: AccessRules<Role, Permission> = {
  [Role.STUDENT_USER]: {
    [Permission.CUSTOMIZER_ACCESS]: true,
    [Permission.EMOTES_ACCESS]: true,
    [Permission.SHAREABLE_LINKS_ACCESS]: true,
    [Permission.STUDENT_EGG_HATCHING]: true,
    [Permission.UGC_REPORT_ACCESS]: true,
    [Permission.HAS_BLOCK_INVENTORY]: true,
    [Permission.HAS_PERSISTENT_INVENTORY]: true,
    [Permission.HAS_BUILDING_PLOT]: true,
    [Permission.SYNC_BUILDING_PLOT]: true,
    [Permission.SEE_MEMBER_NAMES]: true,
    [Permission.SEE_INVITER_NAMES]: true,
    [Permission.POCKET_WORLD_CREATE_GATEWAY]: true,
    [Permission.POCKET_WORLD_CAN_BUILD]: true,
    [Permission.HAS_FTUE]: true,
    [Permission.ISLAND_MAP_BUTTON]: true,
  },
  [Role.TEACHER_USER]: {
    [Permission.CUSTOMIZER_ACCESS]: true,
    [Permission.EMOTES_ACCESS]: true,
    [Permission.TEACHER_SNAP_AND_SHARE_ACCESS]: true,
    [Permission.HAS_BLOCK_INVENTORY]: true,
    [Permission.HAS_PERSISTENT_INVENTORY]: true,
    [Permission.SEE_MEMBER_NAMES]: true,
    [Permission.SEE_INVITER_NAMES]: true,
    [Permission.HAS_FTUE]: true,
  },
  [Role.ANONYMOUS_GUEST_USER]: {
    [Permission.EMOTES_ACCESS]: true,
    [Permission.SEE_INVITER_NAMES]: true,
    [Permission.OPEN_SIGNUP_ACCESS]: true,
  },
  [Role.PUBLIC_GUEST_USER]: {
    [Permission.EMOTES_ACCESS]: true,
    [Permission.SEE_INVITER_NAMES]: true,
    [Permission.OPEN_SIGNUP_ACCESS]: true,
  },
  [Role.VISITOR_GUEST_USER]: {
    [Permission.CUSTOMIZER_ACCESS]: true,
    [Permission.EMOTES_ACCESS]: true,
    [Permission.STUDENT_EGG_HATCHING]: true,
    [Permission.UGC_REPORT_ACCESS]: true,
    [Permission.HAS_BLOCK_INVENTORY]: true,
    [Permission.HAS_PERSISTENT_INVENTORY]: true,
    [Permission.SEE_INVITER_NAMES]: true,
  },
  [Role.VIP_GUEST_USER]: {
    [Permission.EMOTES_ACCESS]: true,
    [Permission.HAS_BLOCK_INVENTORY]: true,
    [Permission.HAS_BUILDING_PLOT]: true,
    [Permission.SEE_MEMBER_NAMES]: true,
    [Permission.SEE_INVITER_NAMES]: true,
    [Permission.POCKET_WORLD_CREATE_GATEWAY]: true,
    [Permission.POCKET_WORLD_CAN_BUILD]: true,
    [Permission.HAS_FTUE]: true,
  },
};
